import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Invoice, InvoiceSearchCommand } from '../../models/invoice/invoice';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class InvoiceProxyService {
  // TODO: CUrrently there is a typo in the URL, it should be invoice-order
  // backend team will fix it
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/invoice-order';

  public getInvoice(id: string): Observable<ApiResponse<Invoice>> {
    return this.httpClient.get<ApiResponse<Invoice>>(`${this.baseUrl}/${id}`);
  }

  public searchInvoice(
    searchCommand: InvoiceSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
    matchAny = false,
  ): Observable<ApiResponse<PaginatedApiResponse<Invoice>>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('matchAny', matchAny.toString());
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Invoice>>>(`${this.baseUrl}/search`, searchCommand, { params });
  }
}
